var render = function render(){var _vm=this,_c=_vm._self._c;return _c('benefit-notification-box-base',{attrs:{"icon-path":_vm.iconPath,"description":_vm.description,"title":_vm.title,"color":_vm.color,"variant":_vm.variant},on:{"description-click":_vm.handleLinkClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }